import ApiServices, {LOAD_CURRENT_MERCHANT_INFO} from "../config/ApiServices";
import api from "../utils/api";
import store  from "../store";
import {setMerchant} from "../store/merchant";

export class LoadCurrentMerchantInfoEvent {
    params = {};

    constructor (params = null) {
        this.params = params;
    }

    static getEventName () {
        return 'LoadCurrentMerchantInfoEvent';
    }
}

export class LoadCurrentMerchantInfoListener {
    async handle (event) {
        event['need_register'] = false;
        let apiServices = ApiServices;
        let res = await api(apiServices[LOAD_CURRENT_MERCHANT_INFO]['apiName'], event.params);
        if(res['status']) {
            let merchant = res['data'];
            store.dispatch(setMerchant({
                merchantId: merchant['id'],
                name: merchant['name'],
                avatar: merchant['avatar'],
                roles: merchant['role'],
                fansCount: merchant['fans_count'],
                merchantFansCount: merchant['merchant_fans_count'],
                userFansCount: merchant['user_fans_count']
            }));
        }else{
            event['need_register'] = true;
        }
    }

    async after (event) {
        if (event !== undefined && event['need_register'] !== undefined && event['need_register']) {
            global.router.history.push({pathname: '/register'});
        }
    }
}